// extracted by mini-css-extract-plugin
export default {"box":"cancellationFilterPage_box__sIhoJ","box__content":"cancellationFilterPage_box__content__-fhVj"};